<template>
    <div class="cart-total" :class="{'show-details':showDetails,top:scrollPosition.top,bottom:scrollPosition.bottom}">
        <div class="cart-total__mask" v-show="showDetails" @click="showDetails=false"></div>
        <div class="cart-total__details" v-show="showDetails">
            <h2>{{ $t('pay.check_details') }}</h2>
            <div class="scroll-container" :class="scrollPosition" ref="scrollContainer">
                <div class="cards">
                    <PlanSubscribeCard
                        v-for="(card,index) in planCards"
                        :key="index"
                        :plan="card.plan"
                        :startedAt="card.startedAt"
                        :endingAt="card.endingAt"
                        :deviceInfo="card.deviceInfo"
                        :quantity="card.quantity"
                        :adjustmentInfo="adjustmentInfo"
                        :needPay="needPay"
                        :simCard="card.simCard"
                        :lockDeviceData="card.lockDeviceData"
                        :showAutoRenew="card.showAutoRenew"
                        :autoRenew="card.autoRenew"
                        mode="show"
                    />
                </div>
                <TotalBox
                    :previewData="previewData"
                    showCoupon
                    class="total-box"
                    @addCoupon="handleAddCoupon"
                />
            </div>
        </div>
        <div class="cart-total__normal">
            <div class="total-content">
                <div class="total-content-title">
                    <button class="showButton button_clear"
                        :class="{active:showDetails}"
                        @click="showDetails=!showDetails"
                    >
                        <CO_Play />
                    </button>
                    <span class="title">{{ $t('cart.total') }}:</span>
                </div>
                <span class="details">{{currency}} {{ totalPrice | toFixed2 }}</span>
            </div>
            <reo-common-button
                :label="button"
                ga-label="Cart confirm(subscribe)"
                @click="subscribe"
                :disabled="disabled"
                :customWidth="'100%'"
            />
            <reo-common-button
                class="checkout-button"
                :ga-label="`Cart cancel(${mode})`"
                to="/user/dashboard/"
                :label="cancelButton"
                colorType="light"
                v-if="showCancelButton"
            />
        </div>
    </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import { CO_Play } from '@/components/icon';
import PlanSubscribeCard from './PlanSubscribeCard.vue';
import { ESubscribeMode, IAdjustmentInfo, IPlan } from '@reolink-cloud/interface';
import { DIALOG_ADD, DIALOG_REDUCE } from '@/store/mutation-types';
import TotalBox from '@/components/TotalBox/index.vue';
import { isMobile } from '@/common/js/utils';

export default Vue.extend({

    components: {
        PlanSubscribeCard,
        TotalBox,
        CO_Play
    },
    props: {

        loading: Boolean,
        button: String,
        disabled: Boolean,
        taxIncluded: Boolean,
        taxData: Array as PropType<any[]>,
        currency: String,
        totalPrice: String as PropType<any>,
        taxTotal: Number,
        shouldExcludeVAT: Boolean,
        totalRegularPrice: Number,
        subTotal: Number,
        VATenabled: Boolean,
        adjustmentInfo: Object as PropType<IAdjustmentInfo>,
        planCards: Array as PropType<Array<{
            plan: IPlan;
            deviceInfo: any;
            startedAt: number;
            endingAt: number;
            quantity: number;
            simCard: any;
            lockDeviceData: unknown;
            autoRenew?: boolean;
            showAutoRenew?: boolean;
        }>>,
        showCancelButton: Boolean,
        cancelButton: String,
        mode: String as PropType<ESubscribeMode>,
        needPay: Boolean,
        simCard: {
            type: String,
            required: false
        },
        previewData: Object as PropType<unknown>

    },
    data() {

        return {
            showDetails: false,
            scrollPosition: {
                top: false,
                bottom: false
            }
        };

    },
    watch: {
        showDetails( newVal ) {

            if ( newVal ) {

                this.$nextTick( this.getScrollPosition );
                this.$store.commit( DIALOG_ADD );

            } else {

                this.$store.commit( DIALOG_REDUCE );

            }

        }
    },
    mounted () {

        $( 'body' ).addClass( 'has-cart-total' );
        if ( this.$refs.scrollContainer ) {

            const scrollContainer = this.$refs.scrollContainer as HTMLDivElement;
            scrollContainer.addEventListener( 'scroll', this.getScrollPosition );
            this.getScrollPosition();

        }

    },
    destroyed () {

        $( 'body' ).removeClass( 'has-cart-total' );
        if ( this.$refs.scrollContainer ) {

            const scrollContainer = this.$refs.scrollContainer as HTMLDivElement;
            scrollContainer.removeEventListener( 'scroll', this.getScrollPosition );

        }

    },
    methods: {

        subscribe (): void {

            if ( !this.loading && !this.disabled ) {

                this.$emit( 'subscribe' );

            }

        },

        handleAddCoupon( code: string, type?: 'add' | 'remove', callback?: ( success: { couponError: string; hasCouponError: boolean; }) => void ): void {

            this.$emit( 'addCoupon', code, type, callback );

        },

        getScrollPosition(  ): void {

            const ref = this.$refs.scrollContainer as HTMLDivElement;
            if ( ref ) {

                this.scrollPosition.top = ref.scrollTop === 0;
                this.scrollPosition.bottom =  ref.scrollTop + ref.offsetHeight >= ref.scrollHeight || ref.scrollTop === ref.scrollHeight;

            }

        }

    },

    computed: {

        isMobile(): boolean {

            return isMobile();

        }

    }

});
</script>

<style lang="less" scoped>
.cart-total {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: @bg_02;
    width: 100%;
    box-sizing: border-box;
    z-index: 17;

    @media @mobile {
        display: block;
    }

    .cart-total__mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: -1;
    }

    .cart-total__normal {
        position: relative;
        z-index: 1;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        padding: 12px 16px;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
        background-color: @bg_02;

        .small /deep/ .reo-button-inner{
            padding: 11px 15px;
            font-size: 12px;
            line-height: normal;
            max-width: 160px;
        }

        @media @snapeak_mobile {
            /deep/ .reo-button-inner{
                background-color: #F6685D;
                border-color: #F6685D;
                font-size: 17px;
                &:hover {
                    background-color: #FF7E74;
                    border-color: #FF7E74;
                }
            }
        }

        .total-content {
            display: flex;
            gap: 5px;
            justify-content: flex-start;
            align-items: start;
            flex-direction: column;
            flex-shrink: 0;

            .showButton {
                svg {
                    height: 16px;
                    transform: rotate(-90deg);
                }
            }

            .showButton.active {
                svg {
                    transform: rotate(90deg);
                }
            }

            .title {
                font-family: @font_02;
                font-size: 16px;
                font-weight: 400;
                line-height: normal;
            }

            .details {
                font-family: @font_01;
                font-size: 18px;
                font-weight: 500;
                line-height: normal;
                color: @red_5;
            }
        }
    }

    .cart-total__details {
        position: relative;
        z-index: 1;

        h2 {
            font-size: 18px;
            line-height: 1.2;
            font-weight: 500;
            padding: 20px 15px;
            background-color: @bg_02;
            box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.3);
        }

        .scroll-container {
            padding: 15px 15px;
            background-color: #FFFFFF;

            .cards {
                display: flex;
                flex-direction: column;
                gap: 10px;
                margin-bottom: 10px;
                /deep/ .cart-content{
                    background-color: @bg_01;
                    gap: 8px;
                }
            }

            .total-box {
                text-align: right;
                display: flex;
                flex-direction: column;
                align-items: end;

                &>div {
                    width: 100%;
                }

                .details-content {
                    text-align: right;
                    font-size: 20px;
                    display: inline-block;
                    padding-bottom: 16px;
                    margin-bottom: 18px;
                    border-bottom: 1px solid @line;

                    .tax-box {
                        margin-top: 20px;
                    }

                    del {
                        margin-right: 14px;
                        font-weight: 400;
                    }

                    @media @mobile {
                        font-size: 0.3rem;
                        width: 100%;
                        padding-bottom: 0.2rem;
                        margin-bottom: 0.24rem;

                        .tax-box {
                            margin-top: 0.28rem;
                        }

                        &:after {
                            content: "";
                            display: table;
                            clear: both;
                        }

                        del {
                            margin: 0 0.12rem;
                        }
                    }
                }

                .total-content {
                    text-align: right;
                    font-size: 20px;
                    font-weight: 500;
                    width: 50%;
                    display: inline-block;

                    @media @mobile {
                        width: 100%;
                    }
                }

                .title {
                    float: left;
                    font-size: 16px;
                    font-weight: 500;
                }

                .details {
                    font-size: 20px;
                    font-weight: 600;
                }

                .incl-tax {
                    text-align: right;
                    font-size: 16px;
                    font-weight: 500;
                    display: inline-block;
                    margin-top: 6px;
                    box-sizing: border-box;

                    @media @mobile {
                        width: 100%;
                    }
                }
            }
        }

    }

    &.top {
        h2 {
            box-shadow: none
        }

    }

    &.bottom {

    }

    .total-box{
        margin-bottom: 0;
        /deep/ .discounts-box .detail-box{
            background-color: @bg_02;
        }
    }

    .button-container {
        @media @mobile {
            flex-shrink: 1;
        }
    }

    .total-content-title {
        display: flex;
        align-items: center;
    }
}

</style>
